import {
  XboxOnboardEnrollmentEvidence,
  XboxOnboardResponse,
  XboxOnboardSubmitRequest,
} from "../../server/crm/api/models/xboxOnboardModels";
import { XboxOnboardScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum XboxOnboardActions {
  FETCH_DATA_START = "@xboxOnboard/FETCH_DATA_START",
  FETCH_DATA_COMPLETED = "@xboxOnboard/FETCH_DATA_COMPLETED",
  FETCH_DATA_ERROR = "@xboxOnboard/FETCH_DATA_ERROR",
  SUBMIT_FORM_START = "@xboxOnboard/SUBMIT_FORM_START",
  SUBMIT_FORM_COMPLETED = "@xboxOnboard/SUBMIT_FORM_COMPLETED",
  SUBMIT_FORM_ERROR = "@xboxOnboard/SUBMIT_FORM_ERROR",
  POLL_NDA_START = "@xboxOnboard/POLL_NDA_START",
  POLL_NDA_COMPLETED = "@xboxOnboard/POLL_NDA_COMPLETED",
  POLL_NDA_ERROR = "@xboxOnboard/POLL_NDA_ERROR",
  POLL_ENROLLMENT_START = "@xboxOnboard/POLL_ENROLLMENT_START",
  POLL_ENROLLMENT_COMPLETED = "@xboxOnboard/POLL_ENROLLMENT_COMPLETED",
  POLL_ENROLLMENT_ERROR = "@xboxOnboard/POLL_ENROLLMENT_ERROR",
  START_ENROLLMENT_START = "@xboxOnboard/START_ENROLLMENT_START",
  START_ENROLLMENT_COMPLETED = "@xboxOnboard/START_ENROLLMENT_COMPLETED",
  START_ENROLLMENT_ERROR = "@xboxOnboard/START_ENROLLMENT_ERROR",
  RETRY_ENROLLMENT_START = "@xboxOnboard/RETRY_ENROLLMENT_START",
  RETRY_ENROLLMENT_COMPLETED = "@xboxOnboard/RETRY_ENROLLMENT_COMPLETED",
  RETRY_ENROLLMENT_ERROR = "@xboxOnboard/RETRY_ENROLLMENT_ERROR",
  RESEND_NDA_START = "@xboxOnboard/RESEND_NDA_START",
  RESEND_NDA_COMPLETED = "@xboxOnboard/RESEND_NDA_COMPLETED",
  RESEND_NDA_ERROR = "@xboxOnboard/RESEND_NDA_ERROR",
  UPDATE_DEVELOPMENT_HARDWARE_ACCESS = "@xboxOnboard/UPDATE_DEVELOPMENT_HARDWARE_ACCESS",
}

export const xboxOnboardActions = {
  updateDevelopmentHardwareAccess: createOnboardingAction(
    XboxOnboardActions.UPDATE_DEVELOPMENT_HARDWARE_ACCESS,
    XboxOnboardScope,
    (hasAccess: boolean) => ({ hasAccess })
  ),
  fetchData: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.FETCH_DATA_START,
    () => ({}),
    XboxOnboardActions.FETCH_DATA_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.FETCH_DATA_ERROR,
    (error: Error) => ({ error })
  ),
  submitForm: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.SUBMIT_FORM_START,
    (request: XboxOnboardSubmitRequest) => ({ request }),
    XboxOnboardActions.SUBMIT_FORM_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.SUBMIT_FORM_ERROR,
    (error: Error) => ({ error })
  ),
  pollNda: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.POLL_NDA_START,
    () => ({}),
    XboxOnboardActions.POLL_NDA_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.POLL_NDA_ERROR,
    (error: Error) => ({ error })
  ),
  pollEnrollment: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.POLL_ENROLLMENT_START,
    () => ({}),
    XboxOnboardActions.POLL_ENROLLMENT_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.POLL_ENROLLMENT_ERROR,
    (error: Error) => ({ error })
  ),
  startEnrollment: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.START_ENROLLMENT_START,
    (evidence?: XboxOnboardEnrollmentEvidence) => ({ evidence }),
    XboxOnboardActions.START_ENROLLMENT_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.START_ENROLLMENT_ERROR,
    (error: Error) => ({ error })
  ),
  retryEnrollment: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.RETRY_ENROLLMENT_START,
    (evidence?: XboxOnboardEnrollmentEvidence) => ({ evidence }),
    XboxOnboardActions.RETRY_ENROLLMENT_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.RETRY_ENROLLMENT_ERROR,
    (error: Error) => ({ error })
  ),
  resendNda: createOnboardingAsyncAction(
    XboxOnboardScope,
    XboxOnboardActions.RESEND_NDA_START,
    () => ({}),
    XboxOnboardActions.RESEND_NDA_COMPLETED,
    (data: XboxOnboardResponse) => ({ data }),
    XboxOnboardActions.RESEND_NDA_ERROR,
    (error: Error) => ({ error })
  ),
};
